import { useCallback } from 'react';
import { useToggle } from 'react-use';

import { Link, RemoveIcon } from '@dreryk/react-components';

import { ActionsCellProps } from './ActionsCell';
import { EntitlementStatementsArchiveModal } from './EntitlementStatementsArchiveModal';

export const ArchiveIcon = (props: ActionsCellProps): JSX.Element => {
   const [archiveModalOpen, toggleArchiveModalOpen] = useToggle(false);

   const handleArchive = useCallback((): void => {
      toggleArchiveModalOpen(false);
      props.onArchive();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.onArchive, toggleArchiveModalOpen]);

   return (
      <>
         <Link onClick={toggleArchiveModalOpen} icon={<RemoveIcon />} testId={'archive'} />
         {archiveModalOpen ? (
            <EntitlementStatementsArchiveModal
               id={props.id}
               onCancel={toggleArchiveModalOpen}
               onArchive={handleArchive}
            />
         ) : null}
      </>
   );
};
